import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dialing-wrapper" }
const _hoisted_2 = {
  key: 0,
  id: "local",
  class: "dialing-local"
}
const _hoisted_3 = {
  key: 1,
  class: "dialing-content"
}
const _hoisted_4 = { class: "dialing-user-id" }
const _hoisted_5 = {
  key: 1,
  class: "microphone-icon-container"
}
const _hoisted_6 = { class: "dialing-info" }

import { status, remoteList, dialingInfo, callType } from "../store"
import { STATUS, CALL_TYPE_STRING } from '../constants'
import MicrophoneIcon from "./MicrophoneIcon.vue";
import MicrophoneClosedSVG from '../icons/microphoneClosed.vue';
import "../style.css"
import { onMounted, onUnmounted } from "vue";
import { TUICallKitServer } from "../";
import { isMobile } from "../utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'Dialing',
  setup(__props) {

onMounted(() => {
  if (status.value === STATUS.DIALING_C2C && callType.value === CALL_TYPE_STRING.VIDEO) {
    TUICallKitServer.startLocalView("local");
    const dialingWrapper = document.getElementsByClassName("dialing-wrapper")[0] as HTMLElement;
    dialingWrapper.style.opacity = "100%";
  }
});

onUnmounted(() => {
  console.log("TUICallKit stopLocalView because status is ", status.value);
  if (status.value === STATUS.IDLE) return;
  TUICallKitServer.stopLocalView();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(status) === _unref(STATUS).DIALING_C2C && _unref(callType) === _unref(CALL_TYPE_STRING).VIDEO)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (!_unref(isMobile) || _unref(status) === _unref(STATUS).BE_INVITED || _unref(status) === _unref(STATUS).CALLING_C2C_AUDIO)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_unref(remoteList).length >= 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(remoteList)[0].userID), 1)
                ], 64))
              : _createCommentVNode("", true),
            (_unref(status) === _unref(STATUS).CALLING_C2C_AUDIO)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_unref(remoteList)[0]?.microphone)
                    ? (_openBlock(), _createBlock(MicrophoneIcon, {
                        key: 0,
                        volume: _unref(remoteList)[0]?.volume
                      }, null, 8, ["volume"]))
                    : (_openBlock(), _createBlock(MicrophoneClosedSVG, { key: 1 }))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(dialingInfo)), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})